import { createContext } from 'react';

import { OptionType } from '@shared/ui/MultiSelect';

export interface UploadMediaItem {
    id: string;
    file: File;
    isUploading: boolean;
    errorText?: string;
    date?: string;
    description?: string;
    albums: OptionType[];
}

export interface UploadedProgressMediaItem {
    id: number;
    preview_url: string;
    original_url: string;
    date: string;
    description: string;
    video_url?: string;
    mime_type?: string;
    albums: OptionType[];
}

export interface ProgressContextProps {
    uploadMediaList: UploadMediaItem[];
    uploadedProgressMediaList: UploadedProgressMediaItem[];
    isUploadQueueStarted: boolean;
    uploadImagesList: File[];
    onImageChange: (images: File[]) => void;
    appendPendingUploadMediaItems: () => string[];
    clearPendingUploadMediaItems: () => void;
    getUploadMediaListSnapshot: () => UploadMediaItem[];
    clearUploadListImages: () => void;
    setUploadQueueStarted: (isStarted: boolean) => void;
    setUploadMediaUploadingState: (ids: string[], isUploading: boolean) => void;
    setUploadMediaError: (ids: string[], errorText: string) => void;
    setUploadMediaMeta: (ids: string[], date: string, description: string) => void;
    removeUploadMediaItems: (ids: string[]) => void;
    setUploadAbortController: (id: string, controller: AbortController | null) => void;
    abortUploadMediaItem: (id: string) => void;
    addUploadedProgressMediaItems: (items: UploadedProgressMediaItem[]) => void;
    clearUploadedProgressMediaList: () => void;
    isActiveMassSelectMode: boolean;
    activeMassSelectModeHandle: (value: boolean) => void;
    selectedMassMediaIds: string[];
    onSelectedMassMediaIds: (id: string) => void;
    onALLSelectedMassMediaIds: () => void;
}

export const ProgressContext = createContext<ProgressContextProps>({} as ProgressContextProps);
